import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '../shared';

import { CreateNewCampaignComponent } from './create-new-campaign/create-new-campaign.component';
import { AzavistaGroupedFieldsModule } from '@azavista/components/grouped-fields';

@NgModule({
    declarations: [CreateNewCampaignComponent],
    imports: [SharedModule, MatDialogModule, AzavistaGroupedFieldsModule,],
})
export class EmailMarketingSharedModule {

}
